export default __webpack_public_path__ + "static/media/logo-light.c88c85e9.png";